module.exports = __webpack_public_path__ + "img/ch16_20_问答赛答题.e9c0c31f.jpg";